import React from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { HookSection } from './components/sections/HookSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { MechanismSection } from './components/sections/MechanismSection';
import { WhatYouGetSection } from './components/sections/WhatYouGetSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { HowItWorksSection } from './components/sections/HowItWorksSection';
import { ProofSection } from './components/sections/ProofSection';
import { FAQSection } from './components/sections/FAQSection';
import { OfferSection } from './components/sections/OfferSection';
import { FooterSection } from './components/sections/FooterSection';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-copper/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <WhatYouGetSection data-id="element-6" />
        <AudienceSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProofSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <OfferSection data-id="element-11" />
      </main>

      <FooterSection data-id="element-12" />
    </div>;
}